import useRequest from '@/websdk/utils/request';

export default (function () {
  const { isRequestSuccessed, data, exec, isLoading } = useRequest({
    url: `/api/shutdown/reason`,
    name: 'SHUTDOWN_REASON_Get',
    method: 'GET',
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
